<template>
  <div
      :id="body"
      class="puzzle">
    <p>{{ data.id }}</p>
    <frame>
      <img class="f1" src="../assets/gallery/frame.png"/>
      <span class="title">{{ data.title }}</span>
      <p1 v-if="data.check === '1'"><img class="p1" alt="truePicture" :src="loadImg()" v-on:click="openModal"></p1>
      <p2 v-else><img class="p2" alt="falsePicture" src="../assets/gallery/lock_icon.png" v-on:click="falseModal"></p2>
    </frame>
    <div id="overlay" v-show="showContent" @click.self="closeModal">
      <div id="content">
        <h1 v-if="data.check === '1'">
          <img class="piece" :src="loadImg()" />
          <button v-on:click="closeModal" class="backButton">とじる</button>
        </h1>
        <h1 v-else>
          <p>{{ message }}</p>
          <p><router-link :to="data.name">
            <button class="toGame">ゲームをクリアする</button>
          </router-link></p>
          <p><button @click="closeModal" class="backButton">もどる</button></p>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function(){
    return{
      message: '',
      showContent: false,
      player: new Audio(),
      isPlay: false,
      playing: false,
      num: 0
    }
  },
  props: {
    data: Object,
    srcImg: String,
    song: String
  },
  methods: {
    openModal (){
        this.showContent = true;
        this.playSound();
    },
    closeModal (){
        this.showContent = false;
        this.pauseSound();
    },
    falseModal: function(){
        this.message = "まだクリアしてないよ！";
        this.showContent = true;
    },
    playSound (){
      this.player.src = this.loadSon();
      
      var isPlay = !this.isPlay;
      do {
        if(isPlay) {
          this.player.play();
          this.isPlay = !this.isPlay;
          //this.playing = true;
        } else {
          this.player.pause();
          this.isPlay = !this.isPlay;
          break;
        }
      } while(this.playing)
    },
    pauseSound (){
      this.player.pause();
      this.isPlay = false;
      this.playing = false;
    },
    loadImg() {
      return require(`../assets/gallery/${this.srcImg}`);
    },
    loadSon() {
      return require(`../assets/gallery/songs/${this.song}`);
    }
  }
}
</script>

<style>
.body {
  background-color: #faffd1;
  font-family: "Yu Gothic","游ゴシック",YuGothic,"游ゴシック体";
}
.puzzle {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  text-align: center;
}
#overlay{
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content{
  z-index: 2;
  width: 50%;
  padding: 1em;
  background: #faffd1;
}
.h1 {
  font-size: 50px;
  color: red;
  align-items: center;
}
.backButton {
  border: solid 2px red;
  border-radius: 20px;
  background-color: lightblue;
  padding: 20px;
  height: auto;
  font-size: 25px;
}
.frame {
  position: relative;
  width: 200px;
  height: auto;
}
.f1 {
  background-color: rgb(201, 201, 201);
}
span.title {
  position: absolute;
  left: 45%;
  bottom: 2px;
  font: italic 1.2em "Fira Sans", serif;
}
.p1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-41.8%) translateX(-50.6%);
  margin: auto;

  max-height: 242px;
  max-width: 353px;
}
.p2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  width: 100px;
}
.piece {
  width: 100%;
  height: auto;
}
</style>